(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const announcementBars = document.querySelectorAll('.announcement-bar');

  announcementBars.forEach(function (bar) {
    const colorValue = bar.style.getPropertyValue('--bar-color') || '#ff0000';
    const hex = colorValue.replace('#', '').trim();

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    bar.style.setProperty('--bar-color-r', isNaN(r) ? 255 : r);
    bar.style.setProperty('--bar-color-g', isNaN(g) ? 0 : g);
    bar.style.setProperty('--bar-color-b', isNaN(b) ? 0 : b);

    initRotator(bar);
  });

  function initRotator(bar) {
    const messages = bar.querySelectorAll('.announcement-bar__message');
    if (messages.length < 2) return;

    const interval = parseInt(bar.dataset.rotateInterval, 10);
    if (!interval || interval <= 0) return;

    const prefersReducedMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;

    let current = 0;
    let timer = null;

    function showNext() {
      const prev = messages[current];
      current = (current + 1) % messages.length;
      const next = messages[current];

      if (prefersReducedMotion) {
        prev.classList.remove('is-active');
        next.classList.add('is-active');
        return;
      }

      prev.classList.add('is-leaving');
      prev.classList.remove('is-active');
      next.classList.add('is-active');

      window.setTimeout(function () {
        prev.classList.remove('is-leaving');
      }, 650);
    }

    function start() {
      stop();
      timer = window.setInterval(showNext, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    start();

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giveaway-rules"] && !Shopify.designMode) return;
  try {
    
(function() {
  const links = document.querySelectorAll('.gr__sidenav-link');
  if (!links.length) return;

  const headings = Array.from(links).map(link => {
    const id = link.getAttribute('href').slice(1);
    return document.getElementById(id);
  }).filter(Boolean);

  const activate = (id) => {
    links.forEach(l => {
      l.classList.toggle('is-active', l.getAttribute('href') === '#' + id);
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) activate(entry.target.id);
    });
  }, { rootMargin: '-20% 0px -70% 0px' });

  headings.forEach(h => observer.observe(h));

  links.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const target = document.querySelector(link.getAttribute('href'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    link.addEventListener('dragstart', e => e.preventDefault());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  var body  = document.querySelector('.help-article__body');
  var list  = document.querySelector('[data-help-toc]');
  var group = document.querySelector('[data-help-toc-group]');
  if (!body || !list || !group) return;

  var headings = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));
  if (!headings.length) return;

  function slugify(text) {
    return (text || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  }

  headings.forEach(function (h, i) {
    if (h.id) return;
    var base = slugify(h.textContent);
    var candidate = base;
    var n = 2;
    while (document.getElementById(candidate)) {
      candidate = base + '-' + n++;
    }
    h.id = candidate;
  });

  list.innerHTML = headings.map(function (h) {
    var sub = h.tagName === 'H3' ? ' help-article__sidenav-link--sub' : '';
    var text = (h.textContent || '').trim()
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return (
      '<li><a href="#' + h.id + '" class="help-article__sidenav-link' + sub + '">' +
      text +
      '</a></li>'
    );
  }).join('');

  group.hidden = false;

  var links = list.querySelectorAll('.help-article__sidenav-link');

  function activate(id) {
    links.forEach(function (l) {
      l.classList.toggle('is-active', l.getAttribute('href') === '#' + id);
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) activate(entry.target.id);
    });
  }, { rootMargin: '-20% 0px -70% 0px' });

  headings.forEach(function (h) { observer.observe(h); });

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.querySelector(link.getAttribute('href'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    link.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motorcycle-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const galleries = document.querySelectorAll('.motorcycle-gallery');
  
  galleries.forEach(gallery => {
    const mainImage = gallery.querySelector('[data-main-image]');
    const mainImageContainer = gallery.querySelector('[data-main-image-container]');
    const thumbnailsContainer = gallery.querySelector('[data-thumbnails-container]');
    const thumbnails = gallery.querySelectorAll('.motorcycle-gallery__thumbnail-wrapper');
    const prevButtons = gallery.querySelectorAll('[data-nav="prev"]');
    const nextButtons = gallery.querySelectorAll('[data-nav="next"]');
    
    let currentIndex = 0;
    const thumbnailWidth = thumbnails[0].offsetWidth + 15; // Include gap
    const visibleThumbnails = Math.floor(thumbnailsContainer.offsetWidth / thumbnailWidth);
    const maxIndex = thumbnails.length - 1;
    const maxScroll = Math.max(0, thumbnails.length - visibleThumbnails);
    
    // Initialize nav buttons state
    updateNavButtons();
    
    // Handle thumbnail clicks
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', function() {
        updateMainImage(index);
      });
    });
    
    // Navigation buttons - both main and thumbnail nav
    prevButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Loop to the last item if at beginning
        const newIndex = currentIndex <= 0 ? maxIndex : currentIndex - 1;
        updateMainImage(newIndex);
      });
    });
    
    nextButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Loop to the first item if at end
        const newIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
        updateMainImage(newIndex);
      });
    });
    
    function updateMainImage(index) {
      const thumbnail = thumbnails[index];
      const imageUrl = thumbnail.getAttribute('data-image-url');
      const caption = thumbnail.getAttribute('data-caption');
      
      // Update active state
      thumbnails.forEach(thumb => thumb.classList.remove('active'));
      thumbnail.classList.add('active');
      currentIndex = index;
      
      // Update main image with fade effect
      mainImage.style.opacity = '0';
      setTimeout(() => {
        mainImage.src = imageUrl;
        mainImage.style.opacity = '1';
        
        // Update caption
        const captionElement = mainImageContainer.querySelector('.motorcycle-gallery__caption');
        if (captionElement) {
          captionElement.textContent = caption;
        } else if (caption) {
          const newCaption = document.createElement('div');
          newCaption.className = 'motorcycle-gallery__caption';
          newCaption.textContent = caption;
          mainImageContainer.appendChild(newCaption);
        }
      }, 300);
      
      // Ensure clicked thumbnail is visible in carousel
      ensureThumbnailVisible(index);
    }
    
    function scrollThumbnails(index) {
      // Implement looping behavior for thumbnails too
      let scrollIndex = index;
      
      if (index < 0) {
        // If scrolling before the first item, wrap to end
        scrollIndex = maxScroll;
      } else if (index > maxScroll) {
        // If scrolling past the last visible set, wrap to beginning
        scrollIndex = 0;
      }
      
      const scrollPosition = -scrollIndex * thumbnailWidth;
      thumbnailsContainer.style.transform = `translateX(${scrollPosition}px)`;
      
      return scrollIndex;
    }
    
    function ensureThumbnailVisible(index) {
      // Calculate current visible range
      const firstVisible = Math.abs(parseInt(thumbnailsContainer.style.transform.replace('translateX(', '').replace('px)', '') || 0)) / thumbnailWidth;
      const lastVisible = firstVisible + visibleThumbnails - 1;
      
      if (index < firstVisible) {
        // Scroll back to make this thumbnail visible
        scrollThumbnails(index);
      } else if (index > lastVisible) {
        // Scroll forward to make this thumbnail visible
        scrollThumbnails(index - visibleThumbnails + 1);
      } else if (index === 0 && firstVisible > 0) {
        // If selecting the first image but we're scrolled
        scrollThumbnails(0);
      } else if (index === maxIndex && lastVisible < maxIndex) {
        // If selecting the last image but it's not fully visible
        scrollThumbnails(maxScroll);
      }
    }
    
    function updateNavButtons() {
      // With looping behavior, buttons are always enabled
      // This function is kept for potential future use
    }
    
    // Handle keyboard navigation
    gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        const newIndex = currentIndex <= 0 ? maxIndex : currentIndex - 1;
        updateMainImage(newIndex);
      } else if (e.key === 'ArrowRight') {
        const newIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
        updateMainImage(newIndex);
      }
    });
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Recalculate visible thumbnails
        const newVisibleThumbnails = Math.floor(thumbnailsContainer.offsetWidth / thumbnailWidth);
        if (newVisibleThumbnails !== visibleThumbnails) {
          // Reset position to ensure current thumbnail is visible
          ensureThumbnailVisible(currentIndex);
        }
      }, 250);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motorcycle-specs-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Tab functionality
  const tabButtons = document.querySelectorAll('.motorcycle-specs-showcase__tab-button');
  const tabContents = document.querySelectorAll('.motorcycle-specs-showcase__tab-content');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Remove active class from all buttons and content
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
      
      // Add active class to clicked button and corresponding content
      button.classList.add('active');
      const tabId = button.getAttribute('data-tab');
      document.querySelector(`[data-tab-content="${tabId}"]`).classList.add('active');
    });
  });
  
  // 3D tilt effect using vanilla JS (simpler version of tilt.js)
  const modelWrapper = document.querySelector('.motorcycle-specs-showcase__model-wrapper');
  if (modelWrapper) {
    const maxTilt = parseFloat(modelWrapper.getAttribute('data-tilt-max') || '5');
    const perspective = parseFloat(modelWrapper.getAttribute('data-tilt-perspective') || '1000');
    
    // Apply initial 3D perspective
    modelWrapper.style.transformStyle = 'preserve-3d';
    modelWrapper.style.perspective = `${perspective}px`;
    
    // Handle mouse movement
    modelWrapper.addEventListener('mousemove', function(e) {
      const rect = modelWrapper.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      // Calculate rotation based on mouse position
      const rotateY = maxTilt * (e.clientX - centerX) / (rect.width / 2);
      const rotateX = -maxTilt * (e.clientY - centerY) / (rect.height / 2);
      
      // Apply transform
      modelWrapper.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      
      // Move image slightly forward for 3D effect
      const image = modelWrapper.querySelector('.motorcycle-specs-showcase__image');
      if (image) {
        image.style.transform = `translateZ(20px)`;
      }
    });
    
    // Reset on mouse leave
    modelWrapper.addEventListener('mouseleave', function() {
      modelWrapper.style.transform = 'rotateX(0) rotateY(0)';
      
      const image = modelWrapper.querySelector('.motorcycle-specs-showcase__image');
      if (image) {
        image.style.transform = 'translateZ(0)';
      }
    });
    
    // Mobile controls for rotation
    const leftBtn = document.querySelector('.motorcycle-specs-showcase__control--left');
    const rightBtn = document.querySelector('.motorcycle-specs-showcase__control--right');
    let currentRotation = 0;
    
    if (leftBtn && rightBtn) {
      leftBtn.addEventListener('click', function() {
        currentRotation -= 30;
        modelWrapper.querySelector('.motorcycle-specs-showcase__model').style.transform = `rotateY(${currentRotation}deg)`;
      });
      
      rightBtn.addEventListener('click', function() {
        currentRotation += 30;
        modelWrapper.querySelector('.motorcycle-specs-showcase__model').style.transform = `rotateY(${currentRotation}deg)`;
      });
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
